<template>
  <v-dialog v-model="visible" width="450">
    <v-card class="cardStyle">
      <v-card-title class="headline lighten-2 titleCard" primary-title>
        <span>
          {{ title }}
        </span>
        <v-icon style="position: absolute; right: 15px" large @click="reject">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-checkbox v-model="acceptReceiveBytos" style="margin-left:20px" label="Receive comissions with Bytos?" />
      <v-card-text v-html="message" />
      <v-card-actions style="margin-top: 20px">
        <v-col>
          <v-row>
            <v-col cols="12">
              <v-slider
                v-model="amount"
                :max="maxAmmount"
                style="margin-right: 10px"
                label="Amount"
                thumb-label="always"
              />
            </v-col>
          </v-row>
          <v-row v-if="receiver && receiver.stripePublickey && stripeActive && commission>0">
            <v-col cols="12">
              <div>{{ $t('Payment with stripe:') }}</div>
              <PaymentComponent :amount="amount- commission - platformCommission" :user="receiver" :factoring="factoring" @success="onSuccessStripe()" @cancel="onCancelStripe" />
              <span> Commisions & Platfom commission</span>
              <PaymentComponent :id-form="'FormCommission'" :id-card="'CardCommission'" :id-btn="'BtnCommission'" :amount="commission + platformCommission" :user="receiver" :factoring="factoring" @success="onSuccessStripeCommision()" @cancel="onCancelStripe" />
            </v-col>
          </v-row>
          <v-row v-if="receiver && receiver.walletAddress">
            <v-col cols="12">
              <div style="margin-bottom: 15px">
                {{ $t('Payment with crypto:') }}
              </div>
              <v-btn x-large class="btnYes" @click="payWithCrypto">
                Pay with crypto
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Hash from "object-hash";

const IERC20 = require("../../public/IERC20.json");
import ApiRepository from "@/repositories/ApiRepository";
import PaymentComponent from "../components/Payment";
import SmartRepository from "@/repositories/SmartRepository";
import Constants from "../../constants";

export default {
    name: "PaymentModal",
    components: {PaymentComponent
    },
    data: () => ({
        acceptReceiveBytos: false,
        visible: false,
        title: "Title",
        message: "Message",
        onYes: null,
        onNo: null,
        amount: 0,
        maxAmmount: 0,
        factoring: null,
        factoringId: null,
        receiver: null,
        refresh: false,
        stripeActive: false,
        percentage: false,
        commission: 0,
        platformCommission: 0,
    }),
    watch: {
        async amount (oldA, newA) {
            this.calculateCommisions();
            const sleep = ms => new Promise(r => setTimeout(r, ms));
            if (!this.refresh) {
                this.refresh = true;
                this.stripeActive = false;
                await sleep(3000);
                this.refresh = false;
                this.stripeActive = true;
            }
        }
    },
    created () {
        this.$root.$on('show-payment-modal', (event) => {
            this.handleCallbacks(event);
            this.setInformation(event);
            this.show(event);
        });
    },
   
    methods: {
        show () {
            this.visible = true;
        },
        hide () {
            this.visible = false;
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.hide();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.hide();
        },
        setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            this.maxAmmount =  jInfo.maxAmmount;
            this.factoringId =  jInfo.factoringId;
            ApiRepository.getFactoringById(this.factoringId).then((res) => {
                this.factoring = res.data.factoring;
                this.receiver = this.factoring.receiver;
                ApiRepository.getMarketItem(this.factoringId).then((res) => {
                    this.percentage = res.data.item.percentage;
                }).catch((err ) => {
                    this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                    console.log(err);
                });
            }).catch((err ) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        calculateCommisions(){
            ApiRepository.getParametersMarket().then((res) => {
                this.commission = (res.data.params.userCommision * this.amount) / 100;
                this.platformCommission = (res.data.params.platformCommision * this.amount) / 100;
                if(!this.commission){this.commission = 0;}
                if(!this.platformCommission){ this.platformCommission=0;}
            });
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        },
        onSuccessStripe () {
            this.saveCollateral(Constants.PAYMENT_MODE.STRIPE);

        },
        onSuccessStripeCommision(){
            this.$root.$emit('show-snackbar', {message: this.$t('Payment Commissions Accepted'), color: "success"});
        },
        onCancelStripe () {
            this.reject();
        },
        addCollateral () {
            const mySTR = this.factoringId.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.transaction(Constants.contractMarketplace, "addCollateral", [hash,  SmartRepository.parseEther(this.amount),  SmartRepository.parseEther(this.commission),  SmartRepository.parseEther(this.platformCommission)])
                .then(() => {
                    this.saveCollateral(Constants.PAYMENT_MODE.CRYPTO);
                    this.$root.$emit('stop-loading');
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    if (e.data && e.data.message) {
                        message = e.data.message;
                    }
                    this.$root.$emit('stop-loading');
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        async payWithCrypto () {
            console.log("Patata 0");
            this.$root.$emit('start-loading');
            SmartRepository.call(Constants.contractByto, "allowance", [await SmartRepository.getMyAddress(), Constants.contractMarketplace.address])
                .then((res) => {
                    if (res.toString() === '0') {
                        const BN = SmartRepository.getBN();
                        const maxNumber = (BN.from(2)).pow(BN.from(256)).sub(BN.from(1));
                        SmartRepository.transaction(Constants.contractByto, "increaseAllowance", [Constants.contractMarketplace.address, maxNumber])
                            .then(() => {
                                this.addCollateral();
                            }).catch((e) => {
                                let message = e.toString();
                                if (e.message) {
                                    message = e.message;
                                }
                                if (e.data && e.data.message) {
                                    message = e.data.message;
                                }
                                this.$root.$emit('stop-loading');
                                this.$root.$emit('show-snackbar', {message: message, color: "error"});
                            });
                    } else {
                        this.addCollateral();
                    }
                });
        },
        saveCollateral (type) {
            ApiRepository.addCollateralBlockchain(this.factoringId, this.amount, this.acceptReceiveBytos)
                .then((res) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Payment Accepted'), color: "success"});
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: 'errorCode' + this.$t(err.response.data.errorCode), color: "error"});
                });
        }
    },
};
</script>
<style>

</style>
